import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.239"
    height="23.239"
    viewBox="0 0 23.239 23.239"
    className={className}
  >
    <g transform="translate(157 -312)">
      <g transform="translate(-159 310)">
        <path
          d="M25.239,7.81a1.712,1.712,0,0,0-.123-.52L22.793,2.642A1.162,1.162,0,0,0,21.753,2H5.486a1.162,1.162,0,0,0-1.039.642L2.123,7.29A1.716,1.716,0,0,0,2,7.81V8.972a4.608,4.608,0,0,0,1.162,3.042V24.077a1.165,1.165,0,0,0,1.162,1.162H22.915a1.165,1.165,0,0,0,1.162-1.162V12.013a4.608,4.608,0,0,0,1.162-3.042ZM20.591,11.3a2.326,2.326,0,0,1-2.324-2.324h4.648A2.326,2.326,0,0,1,20.591,11.3ZM4.324,8.972H8.972a2.324,2.324,0,1,1-4.648,0Zm11.62,0a2.324,2.324,0,1,1-4.648,0ZM6.2,4.324H21.035L22.2,6.648H5.042Zm6.253,18.591V19.429a1.162,1.162,0,0,1,2.324,0v3.486Zm4.648,0V19.429a3.486,3.486,0,0,0-6.972,0v3.486H5.486V13.455a4.6,4.6,0,0,0,1.162.165,4.618,4.618,0,0,0,3.486-1.606,4.586,4.586,0,0,0,6.972,0,4.489,4.489,0,0,0,4.648,1.441v9.461Z"
          transform="translate(0)"
          fill="#b5b5b5"
        />
      </g>
    </g>
  </svg>
);
